import { useNavigate } from 'react-router';
import { useMutation } from '@tanstack/react-query';
import * as R from 'Router/routes';
import { fetchData } from 'utils';
import { useStore } from 'hooks/useStore';
import useSmartlook from 'hooks/useSmartlook';

export default function useBankIDAuthInitMutation() {
  const navigate = useNavigate();
  const { error } = useSmartlook();
  const [storeBankId, setStoreBankId] = useStore((store) => store.bankId);
  return useMutation<
    Record<'url', string>,
    unknown,
    {
      product: 'MTP_CZ';
      clientNumber: string;
    }
  >({
    mutationFn: async (payload) => {
      try {
        const resp = await fetchData(`/client/bankid/auth/init`, {
          method: 'POST',
          body: JSON.stringify(payload),
        });

        return resp;
      } catch (e) {
        error('[useBankIDAuthInitMutation][POST /client/bankid/auth/init]', e);
        setStoreBankId({
          bankId: {
            ...storeBankId,
            error: true,
          },
        });
        navigate(R.BANK_ID_ERROR);
        return undefined;
      }
    },
  });
}
